import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withSnackbar } from "notistack";
import CircularProgress from "@material-ui/core/CircularProgress";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import {
  createPaymentSession,
  PaymentProviders,
  PaymentMethods,
  ClientTypes,
} from "../../services/paymentSessionService";

const styles = (theme) => ({
  progress: {
    margin: theme.spacing.unit * 2,
  },
  card: {
    minWidth: "80%",
    marginBottom: "10px",
    textAlign: "center",
  },
  button: {
    marginTop: theme.spacing.unit * 2,
  },
});

class MercadoPago extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: "",
    };
  }

  loguedIn = function () {
    return !!localStorage.getItem("usr");
  };

  getSelectedAccount = function () {
    if (!this.props.account || !this.props.account.Cuentas) {
      return null;
    }

    return this.props.account.Cuentas[this.props.step2.concepto];
  };

  getEnrollmentNumber = function (selectedAccount) {
    if (!selectedAccount) {
      return "";
    }

    return (
      selectedAccount.Matricula_SE ||
      selectedAccount.Matricula_Inea ||
      selectedAccount.Matricula_Interna ||
      ""
    );
  };

  getPaymentData = function () {
    const selectedAccount = this.getSelectedAccount();

    if (!selectedAccount) {
      throw "No se encontró la cuenta seleccionada.";
    }

    const amount = Number(this.props.step2.cantidad);

    if (!amount || amount <= 0) {
      throw "No hay saldo pendiente para pagar en esta cuenta.";
    }

    return {
      PersonId: selectedAccount.id_Persona || this.props.account.id_Persona,
      StudentId: selectedAccount.id_Alumno,
      AccountId: selectedAccount.id_Cuenta,
      Amount: amount,
      Concept: selectedAccount.Nombre_Cuenta,
      EnrollmentNumber: this.getEnrollmentNumber(selectedAccount),
      Provider: PaymentProviders.MERCADO_PAGO,
      PaymentMethod: PaymentMethods.CHECKOUT,
      Client: ClientTypes.WEB,
    };
  };

  getCheckoutUrl = function (session) {
    if (!session) {
      return "";
    }

    return session.CheckoutUrl || session.checkoutUrl || "";
  };

  getPaymentSessionId = function (session) {
    if (!session) {
      return "";
    }

    return (
      session.PaymentSessionId ||
      session.paymentSessionId ||
      session.Payment_Session_Id ||
      session.payment_session_id ||
      ""
    );
  };

  startPayment = () => {
    if (!this.loguedIn()) {
      this.props.enqueueSnackbar(
        "Para pagar con Mercado Pago necesitas iniciar sesión.",
        { variant: "warning", autoHideDuration: 8000 },
      );
      return;
    }

    let paymentData;

    try {
      paymentData = this.getPaymentData();
    } catch (err) {
      this.props.enqueueSnackbar(err, {
        variant: "warning",
        autoHideDuration: 8000,
      });
      return;
    }

    this.setState({
      loading: true,
      error: "",
    });

    createPaymentSession(paymentData)
      .then((session) => {
        const paymentSessionId = this.getPaymentSessionId(session);
        const checkoutUrl = this.getCheckoutUrl(session);

        if (!paymentSessionId) {
          throw "El API no regresó el identificador de la sesión de pago.";
        }

        if (!checkoutUrl) {
          throw "El API no regresó la URL de Mercado Pago.";
        }

        localStorage.setItem("mercadoPagoPaymentSessionId", paymentSessionId);
        console.log("checkoutUrl", checkoutUrl);
        window.location.href = checkoutUrl;
      })
      .catch((err) => {
        const message =
          typeof err === "string"
            ? err
            : "Hubo un error al iniciar el pago con Mercado Pago.";

        this.setState({
          loading: false,
          error: message,
        });

        this.props.enqueueSnackbar(message, {
          variant: "warning",
          autoHideDuration: 10000,
        });
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <Card className={classes.card}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Pago con Mercado Pago
          </Typography>

          <Typography gutterBottom>
            Al continuar, te enviaremos al checkout seguro de Mercado Pago.
          </Typography>

          <Typography gutterBottom>
            Al regresar, verificaremos el estatus real del pago con el servidor.
          </Typography>

          {this.state.error && (
            <Typography color="error" gutterBottom>
              {this.state.error}
            </Typography>
          )}

          {this.state.loading ? (
            <CircularProgress className={classes.progress} />
          ) : (
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={this.startPayment}
            >
              Pagar con Mercado Pago
            </Button>
          )}
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(withSnackbar(MercadoPago));
